import { Component, Input, HostBinding, input } from '@angular/core';

@Component({
    selector: 'sidenav-link', // tslint:disable-line
    template: `
<a [href]="href()" [target]="target()" class="sidenav-link" [ngClass]="linkClass()">
  @if (icon) {
    <i class="sidenav-icon" [ngClass]="icon"></i>
  }
  <div><ng-content></ng-content></div>
  @if (badge) {
    <div class="ms-auto pl-1"><div class="badge" [ngClass]="badgeClass()">{{badge}}</div></div>
  }
</a>
`,
    standalone: false
})
export class SidenavLinkComponent {
  @HostBinding('class.sidenav-item') hostClassMain = true;
  @HostBinding('class.d-block') hostClassBlock = true;

  readonly href = input('');
  @Input() icon = '';
  readonly target = input('_self');
  readonly linkClass = input('');
  @Input() badge: any = null;
  readonly badgeClass = input('');
  @Input() @HostBinding('class.disabled') disabled = false;
  @Input() @HostBinding('class.active') active = false;
}
